export default __webpack_public_path__ + "static/media/videoplayer_wrap.eccd2cc8.png";